import { gql } from "@apollo/client";

export interface Def_MutationResponse {
  code: string;
  success: boolean;
  message: string;
}

export interface CreateResetPasswordEntry {
  username: string;
}

export interface TokenResetPassword {
  token: string;
  password: string;
}
export interface CreateResetResponse {
  user: {
    createResetPasswordToken: Def_MutationResponse;
  }
}

export const CREATE_RESET_PASSWORD_ENTRY = gql`
  mutation CreateResetPasswordToken($username: String!) {
    user {
      createResetPasswordToken(username: $username) {
        code
        success
        message
      }
    }
  }
`;
export interface TokenResetResponse {
  user: {
    resetPassword: Def_MutationResponse
  }
}

export const TOKEN_RESET_PASSWORD = gql`
  mutation ResetPassword($token: String!, $password: String!) {
    user {
      resetPassword(token: $token, password: $password) {
        code
        success
        message
      }
    }
  }
`